import createIcon from '../../createIcon';

/**
 * @component @name OfflineBolt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi4wMjAwMkM2LjQ5MDAyIDIuMDIwMDIgMi4wMjAwMiA2LjQ5MDAyIDIuMDIwMDIgMTJDMi4wMjAwMiAxNy41MSA2LjQ5MDAyIDIxLjk4IDEyIDIxLjk4QzE3LjUxIDIxLjk4IDIxLjk4IDE3LjUxIDIxLjk4IDEyQzIxLjk4IDYuNDkwMDIgMTcuNTEgMi4wMjAwMiAxMiAyLjAyMDAyWk0xMS40OCAyMFYxMy43NEg4LjAwMDAyTDEzIDQuMDAwMDJWMTAuMjZIMTYuMzVMMTEuNDggMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OfflineBolt = createIcon('OfflineBolt', [
  [
    'path',
    {
      d: 'M12 2.02002C6.49002 2.02002 2.02002 6.49002 2.02002 12C2.02002 17.51 6.49002 21.98 12 21.98C17.51 21.98 21.98 17.51 21.98 12C21.98 6.49002 17.51 2.02002 12 2.02002ZM11.48 20V13.74H8.00002L13 4.00002V10.26H16.35L11.48 20Z',
      key: '1hyj13',
    },
  ],
]);

export default OfflineBolt;
